if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, isCbl = false) => ({
        openDetailOnMobile: false,
        isDesktopStickyATC: window.matchMedia('(min-width: 768px)').matches,
        pendingFocusId: null,
        // Client-side variant flow (not combined listings): the sticky selects bind
        // `x-model="options[i]"` and their <option>s read `currentAvailableOptions`,
        // mirrored from the main xVariantSelect through its updated event.
        options: [],
        currentAvailableOptions: [],
        init() {
          if (!isCbl) {
            this.options = this.getStickySelectValues();
            this.$el.addEventListener('change', (event) => {
              if (event.target.matches?.(`#variant-update-sticky-${CSS.escape(sectionId)} select`)) {
                this.selectOptionSticky();
              }
            });
          }


          this.stickyATCDesktopMedia = window.matchMedia('(min-width: 768px)');
          this.handleStickyATCViewportChange = ({ matches }) => {
            this.isDesktopStickyATC = matches;

            if (matches) this.openDetailOnMobile = false;
          };
          this.handleStickyATCViewportChange(this.stickyATCDesktopMedia);
          this.stickyATCDesktopMedia.addEventListener('change', this.handleStickyATCViewportChange);

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);

            if (!isCbl && Array.isArray(e.detail.options)) {
              this.options = [...e.detail.options];
              this.currentAvailableOptions = e.detail.currentAvailableOptions || [];
            }
          });
        },
        getStickySelectValues() {
          return Array.from(
            this.$el.querySelectorAll(`#variant-update-sticky-${CSS.escape(sectionId)} select`)
          ).map((select) => select.value);
        },
        // Hands the sticky choice to the main picker, whose options watcher resolves the
        // variant and dispatches the updated event that syncs this bar back.
        selectOptionSticky() {
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:options:${sectionId}`, {
            detail: { options: this.getStickySelectValues() }
          }));
        },
        destroy() {
          this.stickyATCDesktopMedia?.removeEventListener('change', this.handleStickyATCViewportChange);
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);

          if (!source || !destination) return;

          const focusId = this.pendingFocusId;
          const shouldRestoreFocus = focusId && document.activeElement?.id === focusId;
          destination.innerHTML = source.innerHTML;
          this.pendingFocusId = null;

          if (shouldRestoreFocus) {
            requestAnimationFrame(() => {
              destination.querySelector(`#${CSS.escape(focusId)}`)?.focus({ preventScroll: true });
            });
          }
        },
        changeOptionSticky(event) {
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const selectedOptionValues = Array.from(
            this.$el.querySelectorAll(`#variant-update-sticky-${CSS.escape(sectionId)} select`)
          ).map((select) => select.selectedOptions[0]?.dataset.optionValueId).filter(Boolean);
          this.pendingFocusId = event.target.id;
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              selectedOptionValues: selectedOptionValues
            }
          }));
        }
      }))
    })
  })
}
